export const zahtjev_prekovremeni = {
    templateId: 29.2,
    category: 3,
    templateTitle: 'Zahtjev za prekovremenim radom radnika',
    templateDescription: `<p>U slučaju više sile, izvanrednog povećanja opsega poslova i u drugim sličnim slučajevima prijeke potrebe, radnik je na zahtjev poslodavca dužan raditi prekovremeno. Zahtjev poslodavca mora imati pisani oblik, osim u slučaju prijeke potrebe, kada može biti i usmeni, no tada poslodavac ima rok od 7 dana da pisano potvrdi usmeni zahtjev za prekovremenim radom. </p>`,
    description: `
    <h5>OPIS I SVRHA DOKUMENTA</h5>
    <p>Prekovremeni rad predstavlja rad radnika koji je duži od njegovog radnog vremena (punog ili nepunog). </p>
    <p>U slučaju više sile, izvanrednog povećanja opsega poslova i u drugim sličnim slučajevima prijeke potrebe, radnik je na prethodni pisani zahtjev poslodavca dužan raditi prekovremeno. </p>
    <p>Navedeni zahtjev poslodavca mora biti u pisanom obliku.</p>
    <p>Ipak, ako priroda prijeke potrebe onemogućava poslodavca da prije početka prekovremenog rada uruči radniku pisani zahtjev za prekovremenim radnom, zahtjev poslodavca može biti i usmen, no poslodavac je dužan takav usmeni zahtjev pisano potvrditi u roku od sedam dana od dana kada je prekovremeni rad naložen.</p>
    <p>Primjer potvrde usmenog zahtjeva možete pogledati <a target="_blank" href="/contract?template=29.3">ovdje</a>. </p>
    <p>Posebno je važno naglasiti da ako radnik radi prekovremeno, ukupno trajanje tjednog rada radnika ne može biti duže od 50 sati tjedno.</p>
    <p>Dakle, radnik koji radi u punom radnom vremenu može raditi tjedno najduže 10 sati prekovremeno. </p>
    <p>Osim toga, prekovremeni rad pojedinog radnika ne smije trajati duže od 180 sati godišnje, osim ako je ugovoreno kolektivnim ugovorom, u kojem slučaju ne smije trajati duže od 250 sati godišnje.</p>
    <p>Zabranjen je prekovremeni rad maloljetnika, dok trudnica, roditelj s djetetom do tri godine života, samohrani roditelj s djetetom do šest godina života, radnik koji radi u nepunom radnom vremenu kod više poslodavaca, te radnik koji dopunski kod drugog poslodavca (povrh 40 sati tjedno), mogu raditi prekovremeno samo ako dostave poslodavcu pisanu izjavu o pristanku na takav rad, osim u slučaju više sile.</p>
    <p>Za obavljeni prekovremenom radu radnik ima pravo na povećanu plaću.</p>
    <h5>NAJČEŠĆE GREŠKE</h5>
    <p><strong> - Prekovremeni rad radnika izvan zakonom dopuštenih okvira - prekršaj</strong></p>
    <p>Pojašnjenje: zakonski nije dopušteno da radnik radi duže od 50 sati tjedno (uključujući i prekovremeni rad) te prekovremeno tijekom jedne godine duže nego je to propisano Zakonom o radu. </p>
    <p><strong> -  Netočno evidentiranje ili neevidentiranje prekovremenog rada u evidenciji radnog vremena</strong></p>
    <p>Pojašnjenje: sukladno Pravilniku o sadržaju i načinu vođenja evidencije o radnicima prekovremeni rad se evidentira posebno, uz evidentiranje rada u redovnom radnom vremenu. </p>
    <p><strong> -   Neisplata uvećane plaće za prekovremeni rad</strong></p>
    <p>Pojašnjenje: radniku za prekovremeni rad pripada pravo na povećanu plaću. Ukoliko navedeno pravo nije propisano pravilnikom o radu ili kolektivnom ugovoru, onda se pravo na povećanu plaću mora odrediti ugovorom o radu. Postoci povećanja nisu propisani Zakonom o radu, stoga poslodavac i radnik postotke povaćanja uređuju samostalno prilikom potpisa ugovora o radu.    </p>
    <h5>PRAVNA OSNOVA</h5>
    <p>Zakon o radu. </p>
  `,

  sides: [
    {
      prefix: "Na temelju Zakona o radu,",
      signature: "Za Poslodavca:",
      inputs: [{
        type: "input",
        required: true,
        placeholder: "Poslovni subjekt",
      },
      {
        type: "input",
        required: true,
        placeholder: "Ulica i kućni broj",
      },
      {
        type: "input",
        required: true,
        placeholder: "Mjesto",
      },
      {
        type: "input",
        required: true,
        placeholder: "OIB",
      },
      {
        type: "input",
        placeholder: "Zastupa",
        inSignature: true,
      },
      {
        type: "input",
        placeholder: "Funkcija",
        inSignature: true,
      }],
      suffix: " (u daljnjem tekstu: Poslodavac),",
    }
  ],

  headline: "donosi sljedeću",
  title: "ZAHTJEV ZA PREKOVREMENIM RADOM RADNIKA",

  noArticleNumbers: true,

  articles: [
    {
      title: "",
      mandatory: true,
      statements: [
        {
          type: "choice",
          mandatory: true,
          editable: false,
          choices: [
            {
              parts: [
                { type: 'text', content: 'Od radnika' },
                { type: 'input', value: '', required: true, placeholder: "Ime i prezime" },
                { type: "text", content: "," },
                { type: 'text', content: 'iz',},
                { type: 'input', value: '', required: true, placeholder: "Mjesto"   },
                { type: 'text', content: ',' },
                { type: 'input', value: '', required: true, placeholder: "Ulica i kućni broj" },
                { type: "text", content: "," },
                { type: 'text', content: 'OIB:' },
                { type: "input",  required: true,},
                { type: 'text', content: ', (u daljnjem tekstu: Radnik),'},
                { type: 'text', content: 'zaposlenog na radnom mjestu' },
                { type: 'input', value: '', required: true },
                { type: 'text', content: ', zahtijeva se dana',  },
                { type: "input",  required: true,},
                { type: 'text', content: 'prekovremeni rad u trajanju od',  },
                { type: 'input', value: '', required: true, help: 'Upišite broj sati. Npr 10 sati.' },
                { type: 'text', content: ', u razdoblju od ' },
                { type: "input",  required: true,},
                { type: 'text', content: 'sati do' },
                { type: "input",  required: true,},
                { type: 'text', content: 'sati.' },
              ]
            }, {
              parts: [
                { type: 'text', content: 'Od radnika' },
                { type: 'input', value: '', required: true, placeholder: "Ime i prezime" },
                { type: "text", content: "," },
                { type: 'text', content: 'iz',},
                { type: 'input', value: '', required: true, placeholder: "Mjesto"   },
                { type: 'text', content: ',' },
                { type: 'input', value: '', required: true, placeholder: "Ulica i kućni broj" },
                { type: "text", content: "," },
                { type: 'text', content: 'OIB:' },
                { type: "input",  required: true,},
                { type: 'text', content: ', (u daljnjem tekstu: Radnik),'},
                { type: 'text', content: 'zaposlenog na radnom mjestu' },
                { type: 'input', value: '', required: true },
                { type: 'text', content: ', zahtijeva se od dana',  },
                { type: "input",  required: true,},
                { type: 'text', content: 'prekovremeni rad prema sljedećem rasporedu:',  },
                { type: 'textarea', content: '', required: true, placeholder: "Ovdje upišite raspored u kojemu će radnik raditi prekovremeno."  },
              ]
            }],
        },
      ]
    },
    {
      title: "",
      mandatory: true,
      statements: [
        {
          type: "text",
          mandatory: true,
          editable: false,
          content: "Ovaj Zahtjev stupa na snagu trenutkom dostave Radniku."
        }]
    },
    {
      title: '------------------------------------------------------Obrazloženje------------------------------------------------------',
      mandatory: true,
      dummy: true,
      exampleContent: true,
      statements: [
        {
          type: "text",
          mandatory: true,
          editable: true,
          help: "Za svaki zahtjev potrebno je posebno obrazložiti specifičan razlog zahtijevanja prekovremenog rada.",
          content: "OBRAZLOŽENJE U NASTAVKU JE DANO SAMO RADI PRIMJERA.\r\nTijekom današnjeg dana zaprimili smo narudžbu kupca koju smo dužni isporučiti u roku od 2 (dva) radna dana. \r\nRadi urednog ispunjenja navedene narudžbe, nužno je raditi prekovremeno. \r\nPoslodavac stoga od Radnika zahtijeva prekovremeni rad kako je navedeno u izreci ovog Zahtjeva."
        }]
    },
    {
      mandatory: true,
      static: true,
      type: 2, // date and place
      statements: [
        {
          type: "input",
          mandatory: true,
          parts: [
            {
              type: "text",
              content: "U"
            },
            {
              type: "input",
              value: "",
              placeholder: "Upišite mjesto.",
              required: true,
            },
            {
              type: "text",
              content: ", dana"
            },
            {
              type: "date",
              value: new Date(),
              required: true
            },
            {
              type: "text",
              content: "godine."
            }
          ]
        },
      ]
    },
    {
      mandatory: true,
      static: true,
      type: 3,  // signatures
      statements: [],
    },
    {
      static: true,
      mandatory: false,
      type: 4, 
      statements: [
        {
          type: 'text',
          mandatory: true,
          editable: true,
          content: 'Dostaviti:\r\n1) Radniku\r\n2) Kadrovska služba',
          help: 'Po želji, slobodno dopišite kome želite dostaviti odluku odnosno izmijenite/obrišite predložene unose.'
        }
      ]
    },
    {
      static: true,
      mandatory: true,
      type: 4, 
      statements: [
        {
          type: 'text',
          mandatory: true,
          editable: true,
          help: 'Ako postupak dostave nije uređen kol. ug., sporazumom između radničkog vijeća i poslodavca ili pravilnikom o radu, primjenjuju se odredbe o dostavi određene parničnim postupkom. U tom slučaju, otkaz se može dostaviti prep. pošt. pošiljkom s povr. ili osobno, na radnom mjestu, no ukoliko radnik odbija primiti odluku, navedeno odbijanje može se pisano konstatirati uz potpis dva svjedoka. Otkaz se može dostaviti i putem j. bilježnika.',
          content: 'Potvrđujem primitak Odluke dana _______________ godine.\r\n\r\nPotpis Radnika: ____________________\r\n\r\n',
        },
      ]
    },
  ],
};



// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/29.2_zahtjev_prekovremeni.ts